import type { SVGProps } from 'react';

const SvgArchiveRestore = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M18 3.002h-7c-.55 0-1 .45-1 1s.45 1 1 1h7c.55 0 1 .45 1 1v5H9c0-.55-.45-1-1-1s-1 .45-1 1v7c0 1.65 1.35 3 3 3h8c1.65 0 3-1.35 3-3v-12c0-1.65-1.35-3-3-3m0 16h-8c-.55 0-1-.45-1-1v-5h10v5c0 .55-.45 1-1 1"
    />
    <path
      fill="currentcolor"
      d="M16 15.002h-4c-.55 0-1 .45-1 1s.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1m0-6c.55 0 1-.45 1-1s-.45-1-1-1h-4c-.55 0-1 .45-1 1s.45 1 1 1zm-9-1c.26 0 .51-.1.71-.29a.996.996 0 0 0 0-1.41l-1.29-1.29h.59c.55 0 1-.45 1-1s-.45-1-1-1H4c-.13 0-.25.03-.37.08s-.23.12-.32.21h-.02a1 1 0 0 0-.3.7v3c0 .55.45 1 1 1s1-.45 1-1v-.59l1.29 1.29c.2.2.45.29.71.29z"
    />
  </svg>
);
export default SvgArchiveRestore;
